import React, { useState, useEffect, useRef } from 'react';
import { MessageCircle, Phone, Mail, X } from 'lucide-react';

const FloatingContact = ({ settings = {} }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="bl-float-wrap" ref={wrapRef} data-testid="floating-contact">
      <div className={`bl-float-menu ${open ? 'open' : ''}`}>
        <a
          href="sms:+13466156860"
          className="bl-float-option"
          data-testid="float-sms"
        >
          <MessageCircle size={16} /> SMS / Text
        </a>
        <a
          href="tel:+13466156860"
          className="bl-float-option"
          data-testid="float-call"
        >
          <Phone size={16} /> Call
        </a>
        <a
          href="mailto:sales@blacklineps.com"
          className="bl-float-option"
          data-testid="float-email"
        >
          <Mail size={16} /> Email
        </a>
      </div>
      <button
        className="bl-float-trigger"
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        aria-label="Contact options"
        data-testid="float-trigger"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
};

export default FloatingContact;
